import type { RouteRecordRaw } from 'vue-router';
import {
  createReferralDashboardGuard,
  createReferralLandingGuard,
} from './referral.guard';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const ReferralLandingPage = () => import('../pages/ReferralLanding/index.vue');
const ReferralDashboardPage = () =>
  import('../pages/ReferralDashboard/index.vue');
const ReferralHistoryPageComp = () =>
  import('../pages/ReferralHistoryPage/index.vue');

export const referralRoutes: Array<RouteRecordRaw> = [
  {
    path: '/invitar-colaboradores',
    beforeEnter: createReferralDashboardGuard(),
    component: MainLayout,
    meta: {
      flag: 'feature_referidos_b2b',
    },
    children: [
      {
        path: '',
        name: 'referral-dashboard',
        component: ReferralDashboardPage,
        meta: {
          requiresAuth: true,
          title: 'Invitar Colaboradores',
        },
      },
      {
        path: 'historial',
        name: 'referral-history',
        component: ReferralHistoryPageComp,
        meta: {
          requiresAuth: true,
          title: 'Historial de invitaciones',
        },
      },
    ],
  },
  {
    path: '/referidos/bienvenida',
    beforeEnter: createReferralLandingGuard(),
    component: MainLayout,
    meta: {
      flag: 'feature_referidos_b2b',
    },
    children: [
      {
        path: '',
        name: 'referral-landing',
        component: ReferralLandingPage,
        meta: {
          requiresAuth: true,
          title: 'Programa de Referidos',
        },
      },
    ],
  },
];
